import React, { useRef, useState } from "react";
import styled from "styled-components";
import { FileUplaodIcon } from "../assets/svg/FileUploadIcon";
import { TitleText } from "./Text";
import Avatar from "./Avatar";
import { FileIcon } from "../assets/svg/FileIcon";

interface UploadProps {
  label?: string;
  isImage?: boolean;
}

const FileUploader = ({ label, isImage, ...props }: UploadProps) => {
  const [url, setUrl] = useState("");
  const [filename, setfilename] = useState("");

  const { form, field }: any = props;

  function generatePreviewImgUrl(file: any, callback: any) {
    const reader = new FileReader();
    const url = reader.readAsDataURL(file);
    reader.onloadend = (e) => callback(reader.result);
  }
  const handleChange = (event: any) => {
    const { setFieldValue } = form;
    const file = event.target.files[0];

    // User cancelled
    if (!file) {
      return;
    }
    setfilename(event.target.files[0].name);
    setFieldValue(field.name, file);

    generatePreviewImgUrl(file, (previewImgUrl: any) => {
      // (assuming we use React)
      setUrl(previewImgUrl);
    });
  };
  return (
    <Label>
      <TitleText>{label}</TitleText>
      <Container>
        <ImageSection>
          {isImage ? (
            <Avatar
              bgColor="#F5F6FB"
              url={
                url
                  ? url
                  : "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcS0e_gbILmZG3jIihqdD8vishAVp_sYtcdHwWeYlx3ujo15wLlN&usqp=CAU"
              }
            />
          ) : (
            <FileIcon />
          )}
          <span>{filename ? filename : "No file selected"}</span>
        </ImageSection>
        {filename ? (
          "X"
        ) : (
          <Button>
            <span>Upload file</span>
            <FileUplaodIcon />{" "}
          </Button>
        )}

        <input
          type="file"
          onChange={handleChange}
          style={{ display: "none" }}
        />
      </Container>
    </Label>
  );
};

export default FileUploader;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  /* background-color: #f5f6fb; */
  /* padding: 0 1em; */
`;

const Button = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #214160;
  span {
    padding-right: 1em;
    font-size: 1em;
    font-weight: 600;
  }
`;

const ImageSection = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    font-size: 12px;
    font-weight: normal;
    color: #214160;
    padding-left: 1em;
  }
`;

const Label = styled.label`
  display: flex;
  flex-direction: column;
  color: #214160;
  font-family: "Raleway", sans-serif;
  font-size: 0.8em;
  margin: 0.5em 0;
  position: relative;
  ${TitleText} {
    opacity: 0.4;
    font-weight: normal;
    padding-bottom: 0.5em;
  }
`;
